<template>
  <div class="dropdown-body dropdown-body_general-estimate dropdown-body_height-limited-500">
    <div v-for="offer in offers" :key="offer.id" class="d-contents">
      <div class="dropdown-element__group-title">{{ offer.contractor_team.name }}</div>
      <DropdownMenuElement
        v-for="version in offer.versions"
        :key="version.id"
        @click="changeGeneralSelectedVersionHandler(version, offer)"
      >
        <TenderOfferVersionDropdownInfo
          :version="version"
          :muted="!isVersionAvailable(version.id)"
        />
      </DropdownMenuElement>
    </div>
  </div>
</template>

<script>
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import TenderOfferVersionDropdownInfo from '@/components/tenders/TenderOfferVersionDropdownInfo';

  export default {
    name: 'TenderOffersVersionsList',
    components: { TenderOfferVersionDropdownInfo, DropdownMenuElement },
    props: {
      offers: {
        type: Array,
        required: true,
      },
      showAllVersions: {
        type: Boolean,
        default: true,
      },
      // Если параметр showAllVersions === false, то этим параметром ограничиваем доступные версии
      availableTenderOfferVersionIds: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      isVersionAvailable(versionId) {
        return this.showAllVersions || this.availableTenderOfferVersionIds.includes(versionId);
      },
      changeGeneralSelectedVersionHandler(version, offer) {
        if (this.isVersionAvailable(version.id)) {
          this.$emit('change-general-selected-version', {
            id: version.id,
            offerName: offer.contractor_team.name,
            versionName: version.name,
          });
        }
      },
    },
  };
</script>
